import { z } from 'zod';

import { isoDatetimeToDate } from '../codecs';
import { SessionType } from './session-type';

export type UpdateSessionMetadataPayload = z.output<typeof updateSessionMetadataPayloadSchema>;
export type UpdateSessionMetadataPayloadDTO = z.input<typeof updateSessionMetadataPayloadSchema>;

export const updateSessionMetadataPayloadSchema = z.object({
  description: z.string().nullable().optional(),
  locksAt: isoDatetimeToDate.nullable().optional(),
  title: z.string().nullable().optional(),
  type: z.enum(SessionType).optional(),
});
